export const LoginContent = {
  // Logo alt text
  logoAlt: 'Rise',

  // Tab labels
  tabs: {
    emailLink: 'Email Code',
    password: 'Password',
  },

  // Form labels
  form: {
    email: {
      label: 'Email',
      placeholder: 'Enter your email',
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your password',
    },
  },

  // Email OTP tab
  magicLink: {
    submit: {
      label: 'Send Code',
      sending: 'Sending...',
    },
    success: {
      message:
        "Check your email! We've sent you a 6-digit code. Enter it below to sign in.",
      sendAnother: 'Resend Code',
    },
    codeInput: {
      label: 'Enter 6-digit code',
      placeholder: '000000',
      verify: 'Verify Code',
      verifying: 'Verifying...',
    },
    notGettingEmail: {
      button: 'Not getting the email?',
      drawer: {
        title: 'Not receiving the email?',
        description:
          "If you haven't received the code email, here are some things to check:",
        tips: [
          'Check your spam or junk folder - sometimes emails can end up there',
          'Make sure you entered the correct email address',
          'Wait a few minutes - emails can sometimes be delayed',
          'Try requesting a new code',
          "If you still don't receive it, contact your administrator for assistance. This app is invite-only and requires an administrator to add you.",
        ],
      },
    },
  },

  // Password tab
  password: {
    submit: {
      label: 'Sign In',
      signingIn: 'Signing in...',
    },
    noAccount: {
      message: "Don't have an account yet?",
      linkText: 'Enter your email here to get started.',
    },
  },

  // Error messages
  errors: {
    unexpected: 'An unexpected error occurred. Please try again.',
  },
} as const;

